import { AfterViewInit, Directive, ElementRef, HostBinding, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appClampToggle]',
  standalone: true
})
export class ClampToggleDirective implements AfterViewInit {
  @Input('appClampToggle') lines = 3; // número de linhas
  @Input() clampToggleMoreLabel = 'ver mais';
  @Input() clampToggleLessLabel = 'ver menos';

  private expanded = false;
  private overflow = false;
  private toggleAnchor?: HTMLAnchorElement;

  constructor(private el: ElementRef<HTMLElement>, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    // Aplicar classe base
    this.renderer.addClass(this.el.nativeElement, 'clamp-container');
    this.applyClampState();
    queueMicrotask(() => this.detectOverflow());
  }

  private detectOverflow(): void {
    const native = this.el.nativeElement;
    // Forçar estado colapsado para medir
    this.expanded = false;
    this.applyClampState();
    this.overflow = native.scrollHeight > native.clientHeight + 1;
    if (this.overflow) {
      this.ensureToggleAnchor();
    } else {
      this.removeToggleAnchor();
    }
  } 

  private ensureToggleAnchor(): void {
    if (this.toggleAnchor) return;
    const anchor: HTMLAnchorElement = this.renderer.createElement('a');
    anchor.innerText = this.clampToggleMoreLabel;
    anchor.className = 'clamp-toggle-anchor cursor-pointer';
    anchor.addEventListener('click', (e) => {
      e.preventDefault();
      this.expanded = !this.expanded;
      this.applyClampState();
      anchor.innerText = this.expanded ? this.clampToggleLessLabel : this.clampToggleMoreLabel;
    });
    this.renderer.appendChild(this.el.nativeElement, anchor);
    this.toggleAnchor = anchor;
  }

  private removeToggleAnchor(): void {
    if (this.toggleAnchor) {
      this.renderer.removeChild(this.el.nativeElement, this.toggleAnchor);
      this.toggleAnchor = undefined;
    }
  }

  private applyClampState(): void {
    const native = this.el.nativeElement;
    if (this.expanded) {
      this.renderer.removeClass(native, 'clamp-collapsed');
      this.renderer.setStyle(native, '-webkit-line-clamp', 'unset');
    } else {
      this.renderer.addClass(native, 'clamp-collapsed');
      this.renderer.setStyle(native, '-webkit-line-clamp', this.lines.toString());
    }
  }
}
